<template>
  <section
    class="py-[60px] xl:pt-[140px] xl:pb-[80px] border-b border-gray/30"
    id="join-us"
  >
    <div
      class="w-full flex-y-center md:text-left text-center gap-6 justify-between md:flex-row flex-col join-us-bg rounded-xl p-6 md:p-10"
    >
      <div class="max-w-[600px] space-y-2">
        <h3
          class="text-xl xl:text-[28px] leading-[20px] xl:leading-[28px] font-semibold"
        >
          {{ $t("landing.aboutHero.joinUs.title") }}
        </h3>
        <p class="text-base xl:text-lg text-dark-900 leading-19 font-medium">
          {{ $t("landing.aboutHero.joinUs.description") }}
        </p>
      </div>
      <a href="https://t.me/sarafrobotcommunity" target="_blank">
        <Button
          class="text-white bg-primary rounded-full px-6 py-3"
          :text="$t('landing.aboutHero.joinUs.button')"
        />
      </a>
    </div>
  </section>
</template>

<script setup lang="ts">
import Button from "@/modules/Landing/components/Base/Button/Button.vue";
</script>

<style scoped>
.join-us-bg {
  background: #ebfff3;
}
</style>
